export const EDUCATION = [
    {label: 'No school', _id: '507f1f77bcf86cd799439046'},
    {label: 'Upto 12th grade, no diploma', _id: '507f1f77bcf86cd799439048'},
    {label: 'High school diploma or equivalent degree', _id: '507f1f77bcf86cd799439045'},
    {label: 'Some college, no degree', _id: '507f1f77bcf86cd799439047'},
    {label: "Associate's degree", _id: '507f1f77bcf86cd799439049'},
    {label: "Bachelor's degree", _id: '507f1f77bcf86cd799439050'},
    {label: 'Graduate or professional degree', _id: '507f1f77bcf86cd799439051'},
    {label: 'Other', _id: '507f1f77bcf86cd799439052'},
    {label: 'Prefer Not to Answer', _id: '507f1f77bcf86cd799439057'},
];
